import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  convertToTwelveHour,
} from '../../utils/TimeUtil';
import VibeTooltip from '../VibeTooltip/VibeTooltip';

function TimeLabel({
  className,
  style,
  time,
  midnightNextDay,
  showTooltip,
}) {
  // show the next day label if the time is exactly midnight, and the prop to show the label is true
  const showNextDayLabel = midnightNextDay && (time === '00:00' || time === '24:00');

  // show the time as 00:00 instead of 24:00
  time = time === '24:00'
    ? '00:00'
    : time;

  return (
    <VibeTooltip
      title={showTooltip
        ? convertToTwelveHour({ time })
        : ''}
      placement="right"
      enterDelay={200}
    >
      <div
        className={classNames('TimeLabel', className)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 4,
          ...style,
        }}
      >
        {time}

        {showNextDayLabel && (
          <div>
            (Next Day)
          </div>
        )}
      </div>
    </VibeTooltip>
  );
}

TimeLabel.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  /** Time to show in 24 hour format */
  time: PropTypes.string.isRequired,
  /** Show next day if midnight */
  midnightNextDay: PropTypes.bool,
  /** Show 12 hour tooltip */
  showTooltip: PropTypes.bool,
};

TimeLabel.defaultProps = {
  className: '',
  style: {},
  midnightNextDay: false,
  showTooltip: false,
};

export default TimeLabel;
